<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div class="containerIconLeft" @click="linkBackTo(content)">
              <font-awesome-icon icon="chevron-left" class="IconLeft" />
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardAudio :cardContent="content" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="linkNextTo(content)">
            <font-awesome-icon icon="chevron-right" class="IconRight" />
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>
<script>
import CardAudio from './components/CardAudio.vue';
import '../../../assets/scss/_chineseStyle.scss';
import {mapGetters} from 'vuex';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardAudio, LoadingMDL},
  name: 'CTA02',
  data() {
    return {
      content: {},
      lang: this.$store.getters['language/getLanguage'],
      pageCode: '',
      baseURL: 'CTA0-',
      isModalVisible: false,
      popupData: {},
      cardType: 'img',
      isChange: false,
      newPath: '',
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      handler: '',
      isCompletedLoad: false,
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
      lessonDone: false,
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      popUp: 'template/getPopupData',
      courseTopicID: 'courses/getCourseTopicID',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },

    storeLanguage: function (val) {
      this.lang = val;
    },
    popUp: function (val) {
      this.popupData = val;
      this.isModalVisible = true;
    },
    isChange: function () {
      this.isModalVisible = false;
      let body = {};
      body.code = this.courseCode;
      if (this.$route.params.id == undefined) {
        body.templateCode =
          `CTA02-` + this.$store.getters['necessary/getCodePage'];
      } else {
        body.templateCode = `CTA02-` + this.$route.params.id;
      }
      this.$store.dispatch('template/fetchContent', body);
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'CTA02 Watcher call');
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.onLoad();
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {
    // if (!this.lessonDone) {
    //   this.commitPayloadData();
    // }
  },
  methods: {
    onLoad() {
      this.loading = true;
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();
      //

      const contentId = `CTA02-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
      // this.checkLastLesson();
    },
    checkLastLesson() {
      //compare codeItem
      const currentCode = this.v3Data.codeItem;
      const lastCode = this.v3Data.lastContent;
      //lesson done true if current === last
      if (currentCode === lastCode) {
        this.lessonDone = true;
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    returnData(str) {
      this.isChange = true;
      this.newPath = str[0] + '-' + str[1];
    },
    linkNextTo(path) {
      const action = path.navigate.next.action;

      this.commitPayloadData(action);
    },
    linkBackTo(path) {
      const action = path.navigate.previous.action;

      const previous = action.split('-');
      const previousPath = `/v4/${previous[0]}/${previous[1]}`;

      this.$router.push(previousPath);
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];

      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          const splitPath = path.split('-');

          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;

          //to LTK 01
          this.$router.push(nextPath);
        }
      }
    },
  },
};
</script>
<style></style>
